import { useState, useRef, useEffect } from "react";
import { TARGETS, CONCEPTS } from "../utils/buildPrompt";

const IconDropdown = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="ddm" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#ddm)">
      <path d="M10 12.774L5.28857 8.06253L6.06253 7.28857L10 11.2261L13.9375 7.28857L14.7115 8.06253L10 12.774Z" fill="#111111"/>
    </g>
  </svg>
);

export default function Dropdown({ value, onChange, isLoggedIn, favorites = [], mode = 'target' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  const favoriteItems = favorites
    .filter(f => f.tab === 'target' && f.target)
    .map(f => ({
      value: f.target,
      label: TARGETS[f.target]?.label ?? f.target,
      levelLabel: TARGETS[f.target]?.levels?.[f.level_idx] ?? '',
      detail: f.detail ?? '',
      favoriteData: f,
    }));

  const items = mode === 'concept'
    ? Object.entries(CONCEPTS).map(([k, v]) => ({ value: k, label: v.label }))
    : Object.entries(TARGETS).map(([k, v]) => ({ value: k, label: v.label }));

  const placeholder = mode === 'concept' ? '컨셉을 선택해주세요' : '대상을 선택해주세요';
  const displayLabel = mode === 'concept'
    ? (value ? CONCEPTS[value]?.label : null)
    : (value ? TARGETS[value]?.label : null);

  return (
    <div ref={ref} style={{ position: 'relative', marginBottom: 0 }}>

      {/* 드롭다운 버튼 */}
      <div
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%',
          padding: '11px 44px 11px 16px',
          border: '1px solid #111111',
          borderRadius: 8,
          fontSize: 15,
          color: value ? '#111111' : '#bbbbbb',
          background: '#ffffff',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          userSelect: 'none',
          position: 'relative',
          boxSizing: 'border-box',
          fontFamily: "'DM Mono', monospace",
        }}
      >
        <span>{displayLabel ?? placeholder}</span>
        <span style={{
          position: 'absolute', right: 14, top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          display: 'flex', alignItems: 'center',
        }}>
          <IconDropdown />
        </span>
      </div>

      {/* 드롭다운 메뉴 */}
      {open && (
        <div style={{
          position: 'absolute',
          top: 'calc(100% + 4px)',
          left: 0, right: 0,
          background: '#ffffff',
          border: '1px solid #111111',
          borderRadius: 12,
          overflow: 'hidden',
          zIndex: 100,
        }}>

          {/* 즐겨찾기 섹션 (target 탭만) */}
          {mode === 'target' && favoriteItems.length > 0 && (
            <>
              <div style={{
                padding: '8px 16px',
                fontSize: 13,
                color: '#555555',
                fontWeight: 700,
                letterSpacing: 1.5,
                background: '#eeeeee',
                fontFamily: "'DM Mono', monospace",
              }}>
                즐겨찾기
              </div>
              {favoriteItems.map((item, i) => (
                <div
                  key={`fav-${i}`}
                  onClick={() => { onChange(item.value, item.favoriteData); setOpen(false); }}
                  style={{
                    padding: '11px 16px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eeeeee',
                    background: '#f5f5f5',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: 0, flex: 1 }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: '#111111', flexShrink: 0, fontFamily: "'DM Mono', monospace" }}>
                      {item.label}
                    </span>
                    {item.levelLabel && (
                      <span style={{ fontSize: 15, color: '#888888', flexShrink: 0, fontFamily: "'DM Mono', monospace" }}>
                        {item.levelLabel}
                      </span>
                    )}
                    {item.detail && (
                      <span style={{ fontSize: 15, color: '#bbbbbb', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0, flex: 1, fontFamily: "'DM Mono', monospace" }}>
                        · {item.detail}
                      </span>
                    )}
                  </div>
                  <span style={{ fontSize: 22, color: '#FFD700', flexShrink: 0, marginLeft: 8, lineHeight: 1 }}>★</span>
                </div>
              ))}
              <div style={{ height: 1, background: '#111111' }} />
            </>
          )}

          {/* 일반 목록 */}
          {items.map((item, i) => (
            <div
              key={item.value}
              onClick={() => { onChange(item.value); setOpen(false); }}
              style={{
                padding: '12px 16px',
                fontSize: 15,
                cursor: 'pointer',
                color: '#111111',
                borderBottom: i < items.length - 1 ? '1px solid #eeeeee' : 'none',
                fontWeight: value === item.value ? 700 : 400,
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                fontFamily: "'DM Mono', monospace",
                background: value === item.value ? '#f5f5f5' : '#ffffff',
              }}
            >
              <span>{item.label}</span>
            </div>
          ))}

        </div>
      )}
    </div>
  );
}